import classNames from 'classnames/bind';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo } from '@fortawesome/pro-solid-svg-icons/faRedo';

import Styles from '../story-filters-styles.module.scss';
import * as storyFiltersActions from '../../../actions/storyFilters.action';
import * as storyActions from '../../../actions/stories.actions';
import * as watchlistActions from '../../../actions/watchlistActions';
import * as searchActions from '../../../actions/searchActions';

const cx = classNames.bind(Styles);

const RefreshFeedButton = (props) => {
  const refreshStories = () => {
    const {
      token,
      piwikEnabled,
      watchlistRefresh,
      actions,
      refreshEvent,
    } = props;

    if (refreshEvent) {
      refreshEvent();
    }

    if (watchlistRefresh) {
      if (piwikEnabled && token) _paq.push(['trackEvent', 'Filters', 'Refresh newsfeed']);
      setTimeout(() => actions.fetchTrendingStoriesSuccess(), 900);
    }
  };

  return (
    <button
      className={cx('filters-control-btn', 'refresh-button')}
      aria-label="refresh-button"
      onClick={refreshStories}
      type="button"
    >
      <FontAwesomeIcon
        icon={faRedo}
      />
      <span>Refresh</span>
    </button>
  );
};

function mapStateToProps(state) {
  return {
    stories: state.stories,
    storyFilters: state.storyFilters,
    token: state.watchlistReducer.userToken,
    activeWatchlist: state.watchlistReducer.activeWatchlist,
    activeWatchlistTopics: state.watchlistReducer.activeWatchlistTopics,
    filterOpened: state.storyFilters.filterOpened,
    accessLevels: state.subscriptions.permissions.access_levels,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      ...storyFiltersActions,
      ...storyActions,
      ...watchlistActions,
      ...searchActions,
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(RefreshFeedButton);
